module.exports = __webpack_public_path__ + "static/media/newten_16.060425bf.png";